import React, { useState, useEffect, useContext, Fragment} from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppContext from '../../context/Context.js';
import { getProfile } from '../../helpers/profile.js';
import Publications from '../publication/Publications';
import { LoadingDots } from '../../helpers/utils';

let records = 20;

const CompetitorsAwards = props => {
  
    const { currentUser } = useContext(AppContext);
    const [appliedFilter, setAppliedFilter] = useState({
      orgId: '',
      searchIssued: new Date(),
      downloadFrom: new Date(new Date().setHours(0,0,0,0)),
      verfahrensStufe: 'Zuschlag',
      initialized: true
    });
  
    async function prepFilter() {
        let p = await getProfile(currentUser);
        let from = moment(new Date()).add(-30, 'd');
        let filterFrom = 'FILTER (?downloaded >= "' + new Date(from).toISOString() + '"^^xsd:dateTime)';      
        let orgQuery = '';
        let orgs;
        if(props.filteredIndustry !== 'Alle' && props.filteredIndustry !== '') {
          orgs = p?.notificationRequests?.filter((n) => n.requestType === 'organization' && n.industry === props.filteredIndustry);
        } else {
          orgs = p?.notificationRequests?.filter((n) => n.requestType === 'organization');
        }
        
        for (var i = 0; i < orgs?.length; i++) {            
            orgQuery += `?contractor = <${orgs[i].search.toLowerCase()}> ${(orgs.length > 1 && i < orgs.length - 1) ? ' || ' : ''}`;

          }
        setAppliedFilter({
            ...appliedFilter,
            industries: [{ name: props.filteredIndustry }],
            contractors: orgs?.map(org => org.search.toLowerCase()),
            searchIssued: new Date()
        });
    }


    useEffect(() => {
        prepFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.cList, props.update, props.filteredIndustry])

    return (
    <Fragment>
        <br></br>
        <h6 style={{ display: 'inline' }}>Zuschläge&nbsp;</h6>
                <FontAwesomeIcon
                icon={['far', 'question-circle']}
                transform="shrink-1"
                className="text-400"
                id="CompetitorsAwardsTooltip"
                style={{ display: 'inline' , verticalAlign: 'top'}}
                />
                <UncontrolledTooltip placement="bottom" target="CompetitorsAwardsTooltip">
                Zuschläge an die ausgewählten Auftragnehmer in den letzten 30 Tagen. 50 neueste werden angezeigt.
                </UncontrolledTooltip>
        <br></br>
        {
        (props?.cList && props.cList.length > 0)
        ?        
        <Publications 
          columns ={
              [
                  {colId: 'downloadDate'},
                  {colId: 'industry'},
                  {colId: 'contractingBody'},
                  {colId: 'contractor'},
                  {colId: 'title'},
                  {colId: 'totalValue'}
              ]
          }
          filter={ appliedFilter }
          records={ records }        
        />
        :
        <Fragment>
        { (props.cList?.length === 0) ? <span>Keine Auftragnehmer ausgewählt</span> : <LoadingDots></LoadingDots> }            
        </Fragment>        
        }        
    </Fragment>
    );
};

export default CompetitorsAwards;